<template>
  <Navbar regloginpass logourl="/rental" />

  <section id="dane">
    <div class="container pt-5" data-aos="fade-up">
      <div class="section-caption">
        <h2>Rejestracja</h2>
      </div>
      <div class="row gy-4">
        <div class="col-lg-12" data-aos="fade-up" data-aos-delay="100">
          <div class="tile">
            <div class="card-body">
              <Alert
                v-if="gusDataNotActive"
                :key="alertKey"
                alert-type="alert-warning"
                alert-text="Podany NIP/REGON wskazuje na wpis o działalności gospodarczej skreślony z bazy GUS. Podaj NIP/REGON aktywnej działalności gospodarczej."
              />
              <Alert
                v-if="gusDataError"
                :key="alertKey"
                alert-type="alert-warning"
                alert-text="Nie udało się pobrać danych o działalności gospodarczej z bazy GUS."
              />
              <Alert
                v-if="fetchingGusData"
                :key="alertKey"
                alert-type="alert-info"
                alert-text="Trwa pobieranie danych klienta z bazy GUS..."
              />
            </div>
            <div class="card-body">
              <div class="mx-auto" style="">
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="vat"
                    maxlength="10"
                    name="nip"
                    autocomplete="on"
                    @input="isNIPValid(vat)"
                    class="form-control"
                    placeholder="NIP (bez -) np. 2562355698"
                  />
                </div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="regon"
                    maxlength="14"
                    name="regon"
                    autocomplete="on"
                    @input="checkRegonInput(regon)"
                    class="form-control"
                    placeholder="Numer REGON"
                  />
                </div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="name"
                    name="name"
                    autocomplete="organization"
                    class="form-control"
                    :class="[
                      this.name === null || this.name === ''
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    placeholder="Imię i nazwisko / nazwa firmy"
                    required
                  />
                </div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="address"
                    name="address"
                    autocomplete="street-address"
                    class="form-control"
                    :class="[
                      this.address === null || this.address === ''
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    placeholder="Adres"
                    required
                  />
                </div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="postal"
                    maxlength="6"
                    name="postal"
                    autocomplete="postal-code"
                    @input="isPostalValid(postal)"
                    class="form-control"
                    :class="[
                      isPostalValid(postal) &&
                      this.postal !== null &&
                      this.postal !== ''
                        ? 'is-valid'
                        : 'is-invalid',
                    ]"
                    placeholder="Kod pocztowy"
                    required
                  />
                </div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="place"
                    name="city"
                    autocomplete="address-level2"
                    class="form-control"
                    :class="[
                      this.place === null || this.place === ''
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    placeholder="Miasto"
                    required
                  />
                </div>
                <div class="input-group mb-3" id="telefon-vue">
                  <vue-tel-input
                    v-model="phone"
                    name="phone"
                    :inputOptions="{
                      placeholder: 'Numer telefonu obowiązkowy',
                      required: true,
                      name: 'phone',
                      autocomplete: 'tel',
                    }"
                    :styleClasses="[
                      isPhoneValid(phone)
                        ? 'form-control is-valid display-flex'
                        : 'form-control is-invalid display-flex',
                    ]"
                  >
                  </vue-tel-input>
                </div>
                <div class="input-group mb-3" id="telefon-vue2">
                  <vue-tel-input
                    v-model="mobile"
                    name="mobile"
                    :inputOptions="{
                      placeholder: 'Numer telefonu dodatkowy',
                      required: false,
                      name: 'cellphone',
                      autocomplete: 'mobile tel',
                    }"
                    :styleClasses="[
                      isPhoneValid(mobile) ||
                      mobile === null ||
                      mobile === ''
                        ? 'form-control is-valid display-flex'
                        : 'form-control is-invalid display-flex',
                    ]"
                  >
                  </vue-tel-input>
                </div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="email"
                    name="email"
                    autocomplete="email"
                    class="form-control"
                    :class="[
                      isEmailValid(email) &&
                      this.email !== null &&
                      this.email !== ''
                        ? 'is-valid'
                        : 'is-invalid',
                    ]"
                    placeholder="Adres email"
                    required
                  />
                </div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="emailRepeat"
                    name="emailRepeat"
                    autocomplete="email"
                    class="form-control"
                    :class="[
                      isEmailValid(emailRepeat) &&
                      this.email === this.emailRepeat
                        ? 'is-valid'
                        : 'is-invalid',
                    ]"
                    placeholder="Powtórz adres email"
                    required
                  />
                </div>
                <div class="input-group mb-3" style="height: 1.5rem">
                  <input
                    type="text"
                    v-model="user"
                    minlength="3"
                    maxlength="32"
                    name="username"
                    autocomplete="username"
                    @input="isUsernameValid(user)"
                    class="form-control"
                    :class="[
                      isUsernameValid(user) &&
                      this.user !== null &&
                      this.user !== ''
                        ? 'is-valid'
                        : 'is-invalid',
                    ]"
                    placeholder="Nazwa użytkownika"
                    required
                  />
                </div>
                <h5 class="input-subcaption">
                  Nazwa użytkownika musi mieć od 3 do 32 znaków (dopuszczalne
                  małe i wielkie litery oraz cyfry od 0 do 9)
                </h5>
                <div class="input-group mb-3" style="height: 1.5rem">
                  <input
                    :type="password1Type"
                    v-model="password"
                    minlength="8"
                    name="password"
                    autocomplete="new-password"
                    @input="isPasswordValid(password)"
                    class="form-control"
                    :class="[
                      isPasswordValid(password) &&
                      this.password !== null &&
                      this.password !== ''
                        ? 'is-valid'
                        : 'is-invalid',
                    ]"
                    placeholder="Hasło"
                    required
                  />
                  <img
                    :src="eyeImage1"
                    @click="togglePassword1View"
                    class="imageTogglePassword"
                    alt=""
                  />
                </div>
                <h5 class="input-subcaption">
                  Hasło musi składać się z przynajmniej 8 znaków (bez spacji)
                </h5>
                <div class="input-group mb-3" style="height: 1.5rem">
                  <input
                    :type="password2Type"
                    v-model="passwordRepeat"
                    minlength="8"
                    name="password"
                    autocomplete="new-password"
                    @input="isPasswordValid(passwordRepeat)"
                    class="form-control"
                    :class="[
                      isPasswordValid(passwordRepeat) &&
                      this.password === this.passwordRepeat
                        ? 'is-valid'
                        : 'is-invalid',
                    ]"
                    placeholder="Powtórz hasło"
                    required
                  />
                  <img
                    :src="eyeImage2"
                    @click="togglePassword2View"
                    class="imageTogglePassword"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12">
                <div class="input-group mb-3 d-block">
                  <div class="input-group-text text-start">
                    <label class="text-wrap"
                      ><input
                        type="checkbox"
                        v-model="agreementService"
                        name="rental_agreement"
                        class="form-check-input checkbox-blue mt-1"
                        :class="[
                          this.agreementService === null ||
                          this.agreementService === false
                            ? 'is-invalid'
                            : 'is-valid',
                        ]"
                        placeholder=""
                        value=""
                        required
                      />
                      <span style="color: red; margin-left: 0.25rem">*</span>
                      Potwierdzam, że (zgoda wymagana):
                      <ul style="padding-left: 2rem">
                        <li> zapoznałem się z regulaminem świadczenia
                          usługi "Tester na wynajem"
                          <a
                              href="/rental/regulations"
                              target="_blank"
                              class="alert-link"
                          >(czytaj tu)</a
                          >, akceptuję go i zobowiązuję się do jego przestrzegania;</li>
                        <li> wyrażam zgodę na wystawianie faktur w formie elektronicznej i wysyłanie ich na podany podczas rejestracji adres email;</li>
                        <li> wyrażam zgodę na przetwarzanie moich danych osobowych oraz na otrzymywanie korespondencji elektronicznej dotyczącej aktualizacji oprogramowania oraz abonamentu systemu diagnostycznego CDIF/3 i NEX.</li>
                      </ul>
                    </label>
                  </div>
                </div>
              </div>
              <!--              <div class="col-12">-->
              <!--                <Alert-->
              <!--                  alert-type="alert-info"-->
              <!--                  alert-text="Uwaga: zaznaczenie poniższej zgody jest konieczne, aby otrzymywać informacje m.in.-->
              <!--                      o upływie okresu obowiązywania abonamentu oraz możliwości jego przedłużenia."-->
              <!--                />-->
              <!--              </div>-->
              <div class="col-12">
                <div class="input-group mb-3 d-block">
                  <div class="input-group-text text-start">
                    <label class="text-wrap">
                      <input
                        type="checkbox"
                        name="info_agreement"
                        v-model="agreementNewsletter"
                        class="form-check-input checkbox-blue mt-1"
                        placeholder=""
                        value=""
                      />
                      Zgadzam się na otrzymywanie od Axes System sp. z o.o.
                      informacji handlowych drogą elektroniczną.
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="input-group mb-3 d-block">
                  <div class="input-group-text text-start">
                    <label class="text-wrap">
                      <input
                        type="checkbox"
                        name="phone_agreement"
                        v-model="agreementPhone"
                        class="form-check-input checkbox-blue mt-1"
                        placeholder=""
                        value=""
                      />
                      Zgadzam się na otrzymywanie od Axes System sp. z o.o.
                      informacji handlowych drogą telefoniczną.
                    </label>
                  </div>
                </div>
                <Alert
                  v-if="registrationConfirmLinkNotSendInfo"
                  :key="alertKey"
                  alert-type="alert-danger"
                  alert-text="Nie udało się wysłać maila potwierdzającego"
                />
                <Alert
                  v-if="usernameInUseInfo"
                  :key="alertKey"
                  alert-type="alert-warning"
                  alert-text="Nazwa użytkownika jest już w użyciu"
                />
                <Alert
                  v-if="dataInvalidInfo"
                  :key="alertKey"
                  alert-type="alert-danger"
                  alert-text="Wprowadzono nieprawidłowe dane"
                />
                <Alert
                  v-if="generalErrorInfo"
                  :key="alertKey"
                  alert-type="alert-danger"
                  alert-text="Nie udało sie utworzyć konta. Skontaktuj się z pomocą techniczną"
                />
              </div>
              <div class="text-center">
                <button
                  type="button"
                  id="logButton"
                  class="btn-standard m-2"
                  @click="onBackButtonClick"
                >
                  Wstecz
                </button>
                <button
                  type="button"
                  id="logButton"
                  class="btn-standard m-2"
                  @click="onCreateAccountButtonClick($event)"
                >
                  Załóż konto
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import { RequestResult } from "@/utils/requestResult";
import Alert from "../components/Alert.vue";
import {
  isEmailValid,
  isPhoneValid,
  isPasswordValid,
  makeRequest,
  scrollToTop,
} from "@/utils/helpers";
import { RoutePath } from "@/utils/routePath";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  components: {
    Navbar,
    Footer,
    Alert,
  },

  computed: {
    eyeImage1() {
      return this.eyeImg1Clicked
        ? "/rental/img/eye_off.svg"
        : "/rental/img/eye_on.svg"; // UWAGA: obrazki w folderze img w repo, nie ma ich w source/src/assets bo się nie chcą dodawać do builda dynamicznie
    },

    eyeImage2() {
      return this.eyeImg2Clicked
        ? "/rental/img/eye_off.svg"
        : "/rental/img/eye_on.svg"; // UWAGA: obrazki w folderze img w repo, nie ma ich w source/src/assets bo się nie chcą dodawać do builda dynamicznie
    },
  },

  data() {
    return {
      // dane do zapytania
      name: null,
      address: null,
      postal: null,
      place: null,
      email: null,
      phone: null,
      mobile: null,
      vat: null, // tabela vat w bazie - NIP
      regon: null,
      agreementService: null, // akceptacja regulaminu wypożyczenia
      agreementEmailnotice: null,
      agreementVat: null, // zgoda na faktury na maila
      agreementNewsletter: null,
      agreementPhone: null,
      user: null,
      password: null,

      // dodatkowe dane z formularza nie przekazywane do zapytania
      emailRepeat: null,
      passwordRepeat: null,

      // do poszczególnych popupów/alertów
      usernameInUseInfo: false,
      dataInvalidInfo: false,
      registrationConfirmLinkNotSendInfo: false,
      generalErrorInfo: false,

      alertKey: 0, // do rerenderowania strony

      nipInputFilled: null,

      gusDataNotActive: null,
      gusDataError: null,
      fetchingGusData: null,

      password1Type: "password",
      password2Type: "password",
      eyeImg1Clicked: false,
      eyeImg2Clicked: false,
    };
  },

  mounted() {
    scrollToTop();

    this.nipInputFilled = false;
    this.gusDataNotActive = null;
    this.gusDataError = false;
    this.fetchingGusData = false;
  },

  watch: {
    postal() {
      try {
        let realPostal = this.postal.replace(/-/gi, "");
        let dashedPostal = realPostal.match(/\d{1,2}/g);
        if (this.postal.length === 3) {
          this.postal = dashedPostal.join("-");
        }
      } catch {}
    },

    async vat(value) {
      if (value.length === 10) {
        await this.getNIPData(value);
      }
    },

    async regon(value) {
      if (value.length >= 9 && value.length <= 14) {
        await this.getRegonData(value);
      }
    },
  },

  methods: {
    togglePassword1View() {
      if (this.password1Type === "password") this.password1Type = "text";
      else this.password1Type = "password";

      this.eyeImg1Clicked = !this.eyeImg1Clicked;
    },

    togglePassword2View() {
      if (this.password2Type === "password") this.password2Type = "text";
      else this.password2Type = "password";

      this.eyeImg2Clicked = !this.eyeImg2Clicked;
    },

    isEmailValid,
    isPhoneValid,
    isPasswordValid,

    isPostalValid(input) {
      if (input === null) return false;

      this.postal = input.replace(/[^0-9-]/, "");

      let postalRegExp = new RegExp(/^(\d{2}-\d{3})$/);
      return postalRegExp.test(input);
    },

    isNIPValid(input) {
      if (input === null) return false;
      if (input === "" && !this.gusDataNotActive) return true;

      this.vat = input.replace(/[^0-9]/, "");

      let nipRegExp = new RegExp(/^\d{10}$/);
      return nipRegExp.test(input);
    },

    checkRegonInput(input) {
      this.regon = input.replace(/[^0-9]/g, "");
    },

    isUsernameValid(input) {
      //Nazwa użytkownika musi mieć od 3 do 32 znaków (dopuszczalne małe i wielkie litery oraz cyfry od 0 do 9)
      if (input === null) return false;

      let usernameRegExp = new RegExp(/^[a-zA-Z0-9]{3,32}$/);
      return usernameRegExp.test(input);
    },

    async getNIPData(nip) {
      this.fetchingGusData = true;

      let NIPData = await makeRequest(
        `${this.hostname}?action=${this.request.BirData}&nip=${nip}`,
        "GET"
      );
      this.nipInputFilled = false;

      switch (NIPData.data.error) {
        case 0:
          this.fetchingGusData = false;
          if (NIPData.data.data.bir.active) {
            this.regon =
              NIPData.data.data.bir.regon === ""
                ? NIPData.data.data.bir.regon14
                : NIPData.data.data.bir.regon;
            this.name = NIPData.data.data.bir.name;
            this.address =
              NIPData.data.data.bir.street === ""
                ? `${NIPData.data.data.bir.city} ${NIPData.data.data.bir.house}`
                : `${NIPData.data.data.bir.street} ${NIPData.data.data.bir.house}`;
            this.postal = NIPData.data.data.bir.zipcode;
            this.place =
              NIPData.data.data.bir.street === ""
                ? NIPData.data.data.bir.community
                : NIPData.data.data.bir.city;

            this.gusDataNotActive = false;
          } else {
            this.gusDataNotActive = true;
          }
          this.nipInputFilled = true;
          break;
        default: {
          this.fetchingGusData = false;
          this.gusDataError = true;
        }
      }

      this.alertKey += 1;
    },

    async getRegonData(regon) {
      this.fetchingGusData = true;

      let regonData = await makeRequest(
        `${this.hostname}?action=${this.request.BirData}&regon=${regon}`,
        "GET"
      );
      this.nipInputFilled = false;

      switch (regonData.data.error) {
        case 0:
          this.fetchingGusData = false;
          if (regonData.data.data.bir.active) {
            this.vat = regonData.data.data.bir.nip;
            this.name = regonData.data.data.bir.name;
            this.address =
              regonData.data.data.bir.street === ""
                ? `${regonData.data.data.bir.city} ${regonData.data.data.bir.house}`
                : `${regonData.data.data.bir.street} ${regonData.data.data.bir.house}`;
            this.postal = regonData.data.data.bir.zipcode;
            this.place =
              regonData.data.data.bir.street === ""
                ? regonData.data.data.bir.community
                : regonData.data.data.bir.city;

            this.gusDataNotActive = false;
          } else {
            this.gusDataNotActive = true;
          }
          this.nipInputFilled = true;
          break;
        default: {
          this.fetchingGusData = false;
          this.gusDataError = true;
        }
      }

      this.alertKey += 1;
    },

    onBackButtonClick() {
      this.$router.push(this.routePath.Login);
    },

    async sendRegistrationConfirmLink() {
      let data = {
        action: this.request.SendRegistrationConfirmLink,
        usr: this.user,
        email: this.email,
      };

      let registrationConfirmLinkRequestResponse = await makeRequest(data);

      switch (registrationConfirmLinkRequestResponse.data.error) {
        case RequestResult.OK: {
          return true;
        }
        default: {
          return false;
        }
      }
    },

    async onCreateAccountButtonClick(event) {
      let necessaryDataValid =
        this.name !== null &&
        this.address !== null &&
        this.isPostalValid(this.postal) &&
        this.place !== null &&
        this.email !== null &&
        this.isPhoneValid(this.phone) &&
        (this.mobile === null || this.mobile === "" || this.isPhoneValid(this.mobile)) &&
        this.agreementService &&
        this.isUsernameValid(this.user) &&
        this.isPasswordValid(this.password) && (this.password == this.passwordRepeat);

      this.usernameInUseInfo = false;
      this.dataInvalidInfo = false;
      this.registrationConfirmLinkNotSendInfo = false;
      this.generalErrorInfo = false;

      if (necessaryDataValid) {
        event.preventDefault();

        let data = {
          action: this.request.CreateAccount,
          name: this.name,
          address: this.address,
          postal: this.postal,
          place: this.place,
          country: "pl",
          email: this.email,
          phone: this.phone.replaceAll(" ", ""),
          vat: this.vat,
          usr: this.user,
          pass: this.password,
        };

        if (this.regon !== null && this.regon !== "") data.regon = this.regon;

        if (this.mobile !== null && this.mobile !== "")
          data.mobile = this.mobile.replaceAll(" ", "");

        data.agreement_zoneterms = this.agreementService ? 1 : 0;
        data.agreement_phone = this.agreementPhone ? 1 : 0;
        data.agreement_newsletter = this.agreementNewsletter ? 1 : 0;

        let registrationRequestResponse = await makeRequest(data);

        switch (registrationRequestResponse.data.error) {
          case RequestResult.OK: {
            // wyślij maila z linkiem do potwierdzenia rejestracji na podany wczesniej mail
            if (await this.sendRegistrationConfirmLink()) {
              this.$router.push(this.routePath.RegistrationComplete);
            } else {
              this.registrationConfirmLinkNotSendInfo = true;
            }
            break;
          }
          case RequestResult.InvalidOrMissingParameter: {
            this.dataInvalidInfo = true;
            break;
          }
          case RequestResult.UsernameInUse: {
            this.usernameInUseInfo = true;
            break;
          }
          case RequestResult.GeneralError: {
            this.generalErrorInfo = true;
            break;
          }
        }
      } else {
        this.dataInvalidInfo = true;
      }

      this.alertKey += 1; //forceRerender
    },
  },
};
</script>

<style scoped>
input[type="text"] {
  width: 100%;
}

select {
  width: 100%;
}

#telefon-vue {
  z-index: 99;
}

#telefon-vue2 {
  z-index: 98;
}

.display-flex {
  /* do inputów z numerem telefonu - nadpisujemy display:block Bootstrapa */
  display: flex;
}
</style>
